import React, { useEffect } from "react";
import { UserContextSelectors } from "../../../redux/selectors";
import { EmptyComponent } from "../../common/EmptyComponent";
import Loadable from "react-loadable";
import { ClientProviderEnum } from "../../../constants";
import { useSelector } from "react-redux";
import { PageContextUtils } from "../../../utils";
import { BrandUtils } from "../../../utils/brandUtils";

const getSearchHeaderPC = clientProvider => {
  return Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "search/pc/[request]" */ `./${clientProvider}/SearchPCHeaderSection`
      ),
    loading: EmptyComponent
  });
};

const getSearchHeaderMobile = clientProvider => {
  return Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "search/mobile/[request]" */ `./${clientProvider}/SearchMobileHeaderSection`
      ),

    loading: EmptyComponent
  });
};

const importSearchCss = (clientProvider, isMobile) => {
  import(
    /* webpackChunkName: "search/[request]" */ `./${clientProvider}/css/${
      clientProvider === ClientProviderEnum.Kambi
        ? "search.scss"
        : `search-${isMobile ? "mobile-" : ""}header.scss`
    }`
  );

  if (clientProvider === ClientProviderEnum.Kambi)
    import(
      /* webpackChunkName: "search/simplebar/styles" */ "simplebar-react/dist/simplebar.min.css"
    );
};

const SearchHeaderSection = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isSearchEnabled = BrandUtils.isSearchEnable();
  const { name } = PageContextUtils.getClientProviderData();

  useEffect(() => {
    if (isSearchEnabled) importSearchCss(name, isMobile);
  }, [isSearchEnabled, isMobile, name]);

  if (!isSearchEnabled) return null;

  if (isMobile && name === ClientProviderEnum.Kambi) return null;

  const SearchHeaderSection = isMobile
    ? getSearchHeaderMobile(name)
    : getSearchHeaderPC(name);

  return <SearchHeaderSection />;
};

export default React.memo(SearchHeaderSection);
